import callApi from '../../util/blogapiCaller';
// import { userNotify } from '../../components/Toasts/ToastAdd';

// blog Home Page
export const FETCHING_BLOG_PAGE = 'FETCHING_BLOG_PAGE';
export const FETCH_BLOG_PAGE = 'FETCH_BLOG_PAGE';

// blog Post Page
export const FETCHING_BLOG_POST_PAGE = 'FETCHING_BLOG_POST_PAGE';
export const FETCH_BLOG_POST_PAGE = 'FETCH_BLOG_POST_PAGE';

// blog Author Page
export const FETCHING_BLOG_AUTHOR_PAGE = 'FETCHING_BLOG_AUTHOR_PAGE';
export const FETCH_BLOG_AUTHOR_PAGE = 'FETCH_BLOG_AUTHOR_PAGE';

// blog Category Page
export const FETCHING_BLOG_CATEGORY_PAGE = 'FETCHING_BLOG_CATEGORY_PAGE';
export const FETCH_BLOG_CATEGORY_PAGE = 'FETCH_BLOG_CATEGORY_PAGE';

export function showLoaderForBlogPageLoading(val) {
  return {
    type: FETCHING_BLOG_PAGE,
    isFetchingBlogs: val
  };
}

export function loadBlogPage(data) {
  return {
    type: FETCH_BLOG_PAGE,
    blogList: data,
    allPosts: data.all_posts,
    isFetchingBlogs: false,
    pageNum: data.page,
    totalCount: data.totalcount,
  };
}


export function fetchBlogList(page) {
  return (dispatch) => {
    dispatch(showLoaderForBlogPageLoading(true));
    return callApi(`blog/home?pageNum=${page}`, 'GET')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadBlogPage(res.data));
        } else {
          dispatch(showLoaderForBlogPageLoading(false));
          // dispatch(userNotify('Failed to load blog list, please try again', 'error'));
        }
      });
  };
}

export function showLoaderForBlogPostPageLoading(val) {
  return {
    type: FETCHING_BLOG_POST_PAGE,
    isLoadingPage: val
  };
}

export function loadBlogPostPage(data) {
  return {
    type: FETCH_BLOG_POST_PAGE,
    blogPost: data.post,
    relatedBlogs: data.posts,
    isLoadingPage: false,
    pageNum: 1,
    totalCount: data.totalCount,
  };
}

export function fetchBlogPostPage(url) {
  return (dispatch) => {
    dispatch(showLoaderForBlogPostPageLoading(true));
    return callApi(`blog/${url}/post`, 'GET')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadBlogPostPage(res.data));
        } else {
          dispatch(showLoaderForBlogPostPageLoading(false));
          // dispatch(userNotify('Failed to load blog post info, please try again', 'error'));
        }
      });
  };
}

export function showLoaderForBlogAuthorPageLoading(val) {
  return {
    type: FETCHING_BLOG_AUTHOR_PAGE,
    isLoadingPage: val
  };
}

export function loadBlogAuthorPage(data) {
  return {
    type: FETCH_BLOG_AUTHOR_PAGE,
    allAuthorPosts: data.all_posts,
    blogAuthor: data,
    isLoadingPage: false,
    pageNum: data.page,
    totalCount: data.totalcount,
    isFetchingBlogs: false,
    authorBlogList: data,
  };
}

export function fetchBlogAuthorPage(url, page) {
  const authorUrl = url.url;
  return (dispatch) => {
    dispatch(showLoaderForBlogAuthorPageLoading(true));
    return callApi(`blog/${authorUrl}/author?pageNum=${page}`, 'GET')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadBlogAuthorPage(res.data));
        } else {
          dispatch(showLoaderForBlogAuthorPageLoading(false));
          // dispatch(userNotify('Failed to load blog author page, please try again', 'error'));
        }
      });
  };
}

export function showLoaderForBlogCategoryPageLoading(val) {
  return {
    type: FETCHING_BLOG_CATEGORY_PAGE,
    isFetchingBlogs: val
  };
}

export function loadBlogCategoryPage(data) {
  return {
    type: FETCH_BLOG_CATEGORY_PAGE,
    categoryBlogList: data,
    isFetchingBlogs: false,
    pageNum: data.page,
    totalCount: data.totalcount,
  };
}


export function fetchBlogCategoryList(url, page) {
  return (dispatch) => {
    dispatch(showLoaderForBlogCategoryPageLoading(true));
    return callApi(`blog/category/${url}/page`, 'GET')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadBlogCategoryPage(res.data));
        } else {
          dispatch(showLoaderForBlogCategoryPageLoading(false));
          // dispatch(userNotify('Failed to load blog category list, please try again', 'error'));
        }
      });
  };
}
